// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2H3if","clinicsSelect":"styles_clinicsSelect__2Uh1z"};